module.exports = __webpack_public_path__ + "static/media/Adventure Trail.1762f9ff.png";